<!-- <p>preapproved-selection-dialog works!</p> -->
<div class="preapproved-selection-dialog-container">
  <div class="dialog-header">
    {{
      "
  Cluster Pre-Approved"
    }}<button mat-mini-fab mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div class="dialog-content">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef>No.</th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="visname">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
        >
          Visitor Name
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.firstName + " " + row.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="hostname">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
        >
          Host Name
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.hostName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
        >
          Visit Date
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.visitDateTime | date : "E, MMMM d, y" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Details">
        <th
          style="text-align: center"
          mat-header-cell
          *matHeaderCellDef
          aria-label="row actions"
        >
          Action
        </th>
        <td style="text-align: center" mat-cell *matCellDef="let element">
          <button
            [disabled]="
              ((element.securityStatus == 1 || element.securityStatus == 3) &&
                element.isPreApproved != 'true') ||
              (element.isPreApproved == 'true' &&
                element.checkOut != null &&
                element.checkIn == null) ||
              (element.isPreApproved == 'true' &&
                element.checkIn &&
                element.checkOut == null) ||
              (element.isPreApproved == 'true' &&
                element.checkIn &&
                element.checkOut)
            "
            mat-raised-button
          >
            <mat-icon *ngIf="element.isPreApproved != 'true'">refresh</mat-icon>
            <mat-icon *ngIf="element.isPreApproved == 'true'">launch</mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="purpose">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Purpose
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.purpose?.length == 0 ? "Not Mentioned" : row.purpose }}
        </td>
      </ng-container>
      <ng-container matColumnDef="security">
        <th style="text-align: center" mat-header-cell *matHeaderCellDef>
          Status
        </th>
        <td style="text-align: center" mat-cell *matCellDef="let row">
          <button
            [ngStyle]="
              row.securityStatus == 1
                ? { 'background-color': 'green' }
                : row.securityStatus == -1 || row.securityStatus == 3
                ? { 'background-color': '#FFBF00' }
                : { 'background-color': 'red' }
            "
            class="security-button"
            mat-raised-button
          >
            {{
              row.securityStatus == -1
                ? "Rejected"
                : row.securityStatus == 1
                ? "Approved"
                : row.securityStatus == 3
                ? "Auto Rejected"
                : row.securityStatus == 0 && row.isPreApproved == "true"
                ? "Pre-Approved"
                : "Pending"
            }}
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="time">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
        >
          Visit Time
        </th>
        <td
          style="border-right: 1px solid; text-align: center"
          mat-cell
          *matCellDef="let row"
        >
          <ng-container *ngIf="row.isPreApproved == 'true'; else dateTime">
            <button
              class="security-button"
              [ngStyle]="
                row.checkIn == null
                  ? { 'background-color': 'lightskyblue', color: 'black' }
                  : row.checkIn &&
                    row.checkOut == null &&
                    (getExpectedCheckoutTimeNumber(row) | async) > 15
                  ? { 'background-color': 'green', color: 'white' }
                  : row.checkIn &&
                    row.checkOut == null &&
                    (getExpectedCheckoutTimeNumber(row) | async) <= 15 &&
                    (getExpectedCheckoutTimeNumber(row) | async) >= 2
                  ? { 'background-color': 'orange', color: 'white' }
                  : row.checkIn &&
                    row.checkOut == null &&
                    (getExpectedCheckoutTimeNumber(row) | async) < 2
                  ? { 'background-color': 'red', color: 'white' }
                  : { 'background-color': 'darkgray' }
              "
              mat-raised-button
            >
              {{
                row.checkIn == null
                  ? "Not yet arrived"
                  : row.checkIn &&
                    row.checkOut == null &&
                    (getExpectedCheckoutTimeNumber(row) | async) > 0
                  ? (getExpectedCheckoutTime(row) | async)
                  : row.checkIn &&
                    row.checkOut == null &&
                    (getExpectedCheckoutTimeNumber(row) | async) == 0
                  ? "Time Expired"
                  : row.checkOut != null
                  ? "Visited"
                  : ""
              }}
            </button>
          </ng-container>
          <ng-template #dateTime>
            {{ row.visitDateTime | date : "hh:mm a" }}
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="selection.toggle(row)"
      ></tr>
    </table>
  </div>
  <mat-divider></mat-divider>
  <div class="dialog-action">
    <button
      [disabled]="selection.selected.length < 2"
      (click)="onClickedCluster()"
      mat-raised-button
    >
      Cluster Visitor
    </button>
  </div>
</div>
